import React from 'react';
import * as Panel2 from './panel';
import * as CGReact from './cg/cgreact';

const inputType = 'date' as const;
type PanelDateProps = Panel2.PanelProps<typeof inputType>;

const PanelDate: React.FC<PanelDateProps> = props => {
  const nodeValueQuery = CGReact.useNodeValue(props.input.path);
  if (nodeValueQuery.loading) {
    return <div>-</div>;
  }
  return <div>{nodeValueQuery.result.toString()}</div>;
};

export const Spec: Panel2.PanelSpec = {
  id: 'date',
  Component: PanelDate,
  inputType,
};
